"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$patchNotification = exports.$markNotificationsAsRead = exports.$getUnreadNotificationCount = exports.$getNotifications = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var base = '/notifications';
var $getNotifications = (category, type, limit, page, ignored, read) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "?").concat(_qs.default.stringify({
    category,
    type,
    limit,
    page,
    ignored,
    viewed: read
  }))
});
exports.$getNotifications = $getNotifications;
var $getUnreadNotificationCount = (ignored, read) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/count?").concat(_qs.default.stringify({
    ignored,
    viewed: read
  }))
});
exports.$getUnreadNotificationCount = $getUnreadNotificationCount;
var $markNotificationsAsRead = (category, type) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/viewed?").concat(_qs.default.stringify({
    category,
    type
  }))
});
exports.$markNotificationsAsRead = $markNotificationsAsRead;
var $patchNotification = (_notification, read, ignored) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_notification),
  body: {
    viewed: read,
    ignored
  }
});
exports.$patchNotification = $patchNotification;